import React from "react";

export default function MockNavigation({
  onNext,
  onPrevious,
  disableNext,
  disablePrevious,
  currentPage, // Receive currentPage as a prop
  totalPages, // Receive totalPages as a prop
  handleSubmit, // Receive handleSubmit as a prop
}) {
  return (
    <div className="mt-14 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
      <div className="flex justify-between items-center">
        <button
          onClick={onPrevious}
          disabled={disablePrevious}
          className={`flex items-center px-4 py-2 bg-blue-500 text-white rounded-sm hover:bg-blue-600 ${disablePrevious ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <span className="arrow-left mr-2"></span>
          Previous
        </button>
        {currentPage === totalPages ? (
          <button
            onClick={handleSubmit}
            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-sm hover:bg-blue-600"
          >
            Submit
          </button>
        ) : (
          <button
            onClick={onNext}
            disabled={disableNext}
            className={`flex items-center px-4 py-2 bg-blue-500 text-white rounded-sm hover:bg-blue-600 ${disableNext ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            Next
            <span className="arrow-right ml-2"></span>
          </button>
        )}
      </div>
    </div>
  );
}
